import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Role } from '../constants/Role';
import LearnerNavbar from './LearnerNavbar';
import AdminNavbar from './AdminNavbar';

const Navbar = () => {
  const { authenticated, hasRole, hasAnyRole, loading } = useAuth();

  // Debug logging
  console.log('Navbar Debug:', {
    authenticated,
    loading,
    hasAnyRole: hasAnyRole([Role.ADMIN_DEV, Role.ADMIN_BUSINESS, Role.STAFF_COURSE_MANAGER, Role.STAFF_ACCOUNTING])
  });

  // Show loading state while authentication is being checked
  if (loading) {
    return <div>Loading navbar...</div>;
  }

  if (!authenticated) {
    return <LearnerNavbar />;
  }

  if (hasAnyRole([Role.ADMIN_DEV, Role.ADMIN_BUSINESS, Role.STAFF_COURSE_MANAGER, Role.STAFF_COURSE_MENTOR ,Role.STAFF_ACCOUNTING])) {
    return <AdminNavbar />;
  }

  return <LearnerNavbar />;
};

export default Navbar; 